/**
 * @file Route: technicalmanual
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import { $, $all } from "@olmokit/dom";
import { globalData } from "@olmokit/core/data";
import "components/Title";
import dlSlider from "components/Downloads";
import { replaceFragment } from "@olmokit/core/fragments";
import { FormType } from "components/Form";
import { DialogDownload } from "components/Dialog/Download";
import "./index.scss";

console.log("Route technicalmanual/index.js mounted.");

replaceFragment("contactForm", "components.FormType").then(() => FormType());
DialogDownload();

for (let item of globalData.sliders) {
    // This condition is also manually included in the blade file
    if (['technical-manual', 'safety-data-sheet'].includes(item.name)) {
        const itemSlides = $all('.Downloads:slide--'+item.id);
        const itemContainer = document.querySelector('#category--'+item.id);
        const itemControls = document.querySelector('#controls--'+item.id);
        console.log(item.id+': '+itemSlides.length);
        if (itemSlides.length == 0) {
            itemContainer.style.display = 'none';
        } else if (itemSlides.length < 3) {
            itemControls.style.display = 'none';
        }
    }
}
const glideEl = $all(".glide");
if (glideEl.length > 0) {
    for (let item of globalData.sliders) {
        // This condition is also manually included in the blade file
        if (['technical-manual', 'safety-data-sheet'].includes(item.name)) {
            dlSlider('.Downloads:slider--'+item.id);
        }
    }
}
